import { render, staticRenderFns } from "./EcommSetupPage.vue?vue&type=template&id=23f9ac79&scoped=true"
import script from "./EcommSetupPage.vue?vue&type=script&lang=js"
export * from "./EcommSetupPage.vue?vue&type=script&lang=js"
import style0 from "./EcommSetupPage.vue?vue&type=style&index=0&id=23f9ac79&prod&lang=scss"
import style1 from "./EcommSetupPage.vue?vue&type=style&index=1&id=23f9ac79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f9ac79",
  null
  
)

export default component.exports